import { Field, FieldProps } from "formik";
import * as React from "react";
import { Alert } from "react-bootstrap";
import { FFieldInputI, InputTypeE } from "../../types";

export const FFieldInput: React.FC<FFieldInputI> = (props) => {
    const {
        formName,
        label,
        labelAppend,
        required,
        onBlur,
        type,
        tabIndex,
        id,
        onChange,
        autoFocus,
        min,
        max,
        className,
        floating,
    } = props;

    const inputType: InputTypeE = type ?? InputTypeE.TEXT;

    return (
        <Field name={formName}>
            {({
                field, // { name, value, onChange, onBlur }
                form, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
                meta,
            }: FieldProps) => (
                <div className={`${typeof floating === "undefined" || floating ? "form-floating" : ""} ${className}`}>
                    <input
                        id={id ?? `f_${formName}`}
                        className={"form-control"}
                        type={inputType}
                        name={field.name}
                        value={field.value}
                        placeholder={label?.toString()}
                        onChange={(e) => {
                            form.handleChange(formName)(e);

                            if (onChange) {
                                onChange(e.currentTarget.value);
                            }
                        }}
                        onBlur={(e) => {
                            form.handleBlur(formName)(e);
                            if (onBlur) {
                                onBlur(field.value);
                            }
                        }}
                        tabIndex={tabIndex}
                        autoFocus={autoFocus}
                        min={min}
                        max={max}
                        // {...field}
                    />

                    {typeof floating === "undefined" || floating ? (
                        <label htmlFor={id ?? `f_${formName}`} className={"form-label"}>
                            {required ? <sup>* </sup> : null}
                            {label}
                            {labelAppend === null ? "" : labelAppend ? <>{labelAppend}</> : ":"}
                        </label>
                    ) : null}

                    {meta.touched && meta.error && (
                        <Alert variant={"warning"} className={"mt-2"}>
                            {meta.error}
                        </Alert>
                    )}
                </div>
            )}
        </Field>
    );
};
